// Shared 688/1024 viewport-tier check for the "Load More" responsive
// listings that use it: events-ajax.js's own grid (cols x rows) and
// event-feed-ajax.js's flat list (initial/load counts per viewport) --
// both read Desktop/Tablet/Mobile ACF fields keyed to these same three
// tiers. podcasts-ajax.js has its OWN separate getDevice() with a
// different mobile threshold (480, not 688) for its own grid -- a
// deliberately different responsive tier, not consolidated here.
export const getResponsiveDevice = () => {
    // 688, not 768 -- must match _events.scss's actual 1-column grid
    // breakpoint (container-query('(max-width: 687px)'), see its own
    // "Kept in sync with .events-grid's own 1-column breakpoint" comment),
    // not the project's generic phone/tablet line. At 768 this used to call
    // 688-767px "mobile" while the grid there was already rendering the
    // 2-column tablet layout, applying the wrong admin-configured row count
    // (and thus the wrong Load More step) to an already-tablet-shaped grid.
    // Note: the grid also has a 3-column "mid" tier between 1014-1271px
    // that this two-way tablet/desktop split doesn't separately model --
    // unchanged, not evidenced as a live bug the way the mobile/tablet band was.
    if (window.innerWidth < 688) return 'mobile';
    if (window.innerWidth < 1024) return 'tablet';
    return 'desktop';
};
